import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {PropertyListTabTypes} from "../../offer/detail/actions/fetch_offer_detail_properties";
import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const changeFilterTabHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("filter_tab_clicked", payload), 500);

export const changeFilterTabHit = (selectedTab: PropertyListTabTypes, viewType: ViewType) => {
    const payload = {
        ...getTrackedSiteData(),
        selectedTab,
        viewType
    };

    changeFilterTabHitAlgolytics(payload);
};
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {PropertyListTabTypes} from "../../offer/detail/actions/fetch_offer_detail_properties";
import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const changeFilterTabHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("filter_tab_clicked", payload), 500);

export const changeFilterTabHit = (selectedTab: PropertyListTabTypes, viewType: ViewType) => {
    const payload = {
        ...getTrackedSiteData(),
        selectedTab,
        viewType
    };

    changeFilterTabHitAlgolytics(payload);
};
